import styled from 'styled-components'
import Modal from '@8x8/oxygen-modal'

export default styled(Modal).attrs(({ theme }) => ({
  theme: {
    backgroundColor: 'white',
    color: '#1c2025'
  }
}))`
  font-family: 'Nunito', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  z-index: 100;
  color: #1c2025;

  [data-id="MODAL"] {
    margin-left: 60px;
  }

  [data-id="OVERLAY_CONTAINER"] {
    background-color: #000;
    opacity: 0.6;
  }
`
